import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class ToolTip extends React.Component {
  render() {
    return (
      <OverlayTrigger
        key={this.props.toolTipKey}
        placement={'top'}
        overlay={<Tooltip id={`tooltip-${this.props.key}`}>{this.props.toolTipValue}</Tooltip>}
      >
        {this.props.overlayComponent}
      </OverlayTrigger>
    );
  }
}

export default ToolTip;
